import React, {useEffect,useState} from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import { useGetConfigMutation } from "../../../api/service"
import "../assets/style.scss"

const Advantage = () => {
  const [advantageText, setAdvantageText] = useState('')

  const [getConfig] = useGetConfigMutation();
  useEffect(() => {
    getConfig("MobilUygulamaIndir.Landing.AdvantageText")
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setAdvantageText(payload.configValue)
        }
      })
    }, [getConfig])

    return (
      <Block className="advantage-inner">
        <Block dangerouslySetInnerHTML={{ __html: advantageText }} />
      </Block>
    )
}

export default Advantage
